import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.7230104,17.6886232 L19.4176599,22.9177272 C20.0815851,23.3689153 20.9797304,22.8933628 20.9797304,22.0906379 L20.9797304,2.09063793 C20.9797304,1.53835318 20.5320152,1.09063793 19.9797304,1.09063793 L3.8769614,1.09063793 C3.32467665,1.09063793 2.8769614,1.53835318 2.8769614,2.09063793 L2.8769614,22.0906379 C2.8769614,22.9051179 3.79854559,23.3779719 4.46016746,22.9029622 L11.7230104,17.6886232 Z M4.8769614,3.09063793 L18.9797304,3.09063793 L18.9797304,20.202002 L12.2693558,15.6417882 C11.9223075,15.4059423 11.4649321,15.4118388 11.1240792,15.6565533 L4.8769614,20.1416551 L4.8769614,3.09063793 z"
  }));
});
var StatusRecomend = AbstractIcon.withComponent(Icon);
StatusRecomend.displayName = 'StatusRecomend';
export default StatusRecomend;